import { createFileRoute } from '@tanstack/react-router'
import { CREDIT_ROUTES, toStaticData } from '../../../../credit-route-config'

export const Route = createFileRoute(
  '/_auth/_modules/credit/admin/users/delegation-of-authority/single-no-deviation',
)({
  staticData: toStaticData(
    CREDIT_ROUTES['/credit/admin/users/delegation-of-authority/single-no-deviation'],
  ),
  beforeLoad: async ({ context }) => {
    context.handleRoutePermissions(Route)
  },
})
